import GlobalDispatcher from "../../events/GlobalDispatcher";

export default class BaseDataProvider {
    constructor() {

    };


    action(data) {
        switch (data.action) {
            case 'init':
                this.calculateInit(data);
                break;
        }
    }

    calculateInit(request) {
        let data = {};
        setTimeout(() => {
            GlobalDispatcher.dispatch('dataProvider:hasResponse', data);
        }, 1000);
    }
}